import * as Sentry from '@sentry/react';

export const EventCategory = {
	Ui: 'UI',
	Backend: 'Backend',
	CDN: 'Cdn'
} as const;

export type EventCategory = typeof EventCategory[keyof typeof EventCategory];

export const Log = (breadCrumb: Sentry.Breadcrumb) => {
	if (!Object.values(breadCrumb).length) {
		return;
	}

	if (process.env.NODE_ENV === 'development') {
		console.log('SENTRY_EVENT_SEND');
		console.log(breadCrumb);
	}

	Sentry.addBreadcrumb(breadCrumb);
};
